import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button, Card, CardText } from 'react-bootstrap';
import Auth from '../utils/auth';
import HeroBackground from '../HeroBackground';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login(props) {
  const [formState, setFormState] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [resetError, setResetError] = useState(null);
  const [resetSuccess, setResetSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('https://second-team-productions.onrender.com/crew/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });

      if (!response.ok) {
        throw new Error('Failed to log in');
      }

           const { token } = await response.json();
      const from = location.state?.from || '/';
      Auth.login(token, from);
      navigate(from, { replace: true });
    } catch (e) {
      console.error(e);
      setError("The provided credentials are incorrect"); 
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();
  
    if (!email.trim()) {
      setResetError('Please enter your email address.');
      setResetSuccess(null);
      return;
    }
  
    try {
      const response = await fetch('https://second-team-productions.onrender.com/passwordRoutes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to send password reset email');
      }
  
      setResetSuccess('Please check your email and follow the instructions');
      setResetError(null);
    } catch (e) {
      setResetError('Could not reset password');
      setResetSuccess(null);
    }
  };

  return (
    <div 

    >
                  <h1 className="justify-content-center"
            style={{
              marginBottom: '2%',
            }}
          >Login</h1>
      <form onSubmit={handleFormSubmit}>
        <Card className="card-body container col-10 col-md-6 justify-content-center"
            style={{
            overflow: 'hidden',
            boxSizing: 'border-box',
            // marginTop: '50%',
            width: '420px', maxWidth: '90vw', 
            marginBottom: '2%',
            position: 'relative',
            color: 'silver',
            borderRadius: '10px'
          }}
        >

               {/* <h1 className="justify-content-center"
            style={{
              marginBottom: '1%',
            }}
          >Login</h1> */}

          <div className="container justify-content-center row"
            style={{
              display: 'block', 
              flexWrap: 'wrap', 
              gap: '5%',
              
            }}
          >
            {forgotPassword ? (
              // Reset password form
              <div className="forgot-password-section col-12 justify-content-center"
              style={{
                display: 'block', 
                flexWrap: 'wrap', 
                gap: '5%',
                margin:'2%'}}
              >
                 {resetSuccess ? (
              <CardText>
                {resetSuccess}
              </CardText>
              
            ) : (
              <>
                <div className="flex col-12"
                
                >
                <h5>Email address</h5>
                <input
                  className='form-control about-card-edit'
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                        style={{
                      background: "rgba(37, 37, 36, 0.8)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      boxShadow: `
                    0 0 5px rgba(73, 57, 31, 0.6),
                    0 0 10px rgba(67, 66, 64, 0.35)
                  `, 
                      color: 'white',
                      caretColor: 'white',
                      width: '100%',
                      maxWidth: '100%',
                      paddingRight: '40px', // 👈 space for the icon
                      marginBottom: '10px',
                      boxSizing: 'border-box',
                      fontSize: '1.2rem',
                    }}
                />
                </div>

                <div className="col-12 flex-row flex-end">
                <Button 
                  type="button"
                  onClick={handleForgotPassword}
                  className="process-card-text hover-brighten col-12"
                  style={{
                    display: 'block',
                   
                    width: 'auto',
                    margin: '20px auto',
                    fontSize: '2.5vmin',
                    backgroundColor: 'rgb(67, 66, 66)',
                    color: '#fff',
                     border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                    borderRadius: '999px',
                    cursor: 'pointer',
                    textAlign: 'center',
                  }}
                >
                  <h5 style={{ margin: '1%' }}>Reset Password</h5>
                </Button>
                </div>        
                {resetError && 
                <CardText>
                  {resetError}
                </CardText>}
                </>
                )}
              </div>
            ) : (
              // Login form
              <div className='justify-content-center row'
                style={{
                  display: 'block', 
                  flexWrap: 'wrap', 
                  gap: '5%',
                  margin:'2%'}}
              >
                <div className="flex col-12">
                  <label htmlFor="email">
                    <h5>Email address</h5>
                  </label>
                  <input
                    placeholder=""
                    name="email"
                    type="email"
                    id="email"
                    className="form-control about-card-edit"
                    onChange={handleChange}
                           style={{
                      background: "rgba(37, 37, 36, 0.8)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      boxShadow: `
                    0 0 5px rgba(73, 57, 31, 0.6),
                    0 0 10px rgba(67, 66, 64, 0.35)
                  `, 
                      color: 'white',
                      caretColor: 'white',
                      width: '100%',
                      maxWidth: '100%',
                      // paddingRight: '40px', 
                      marginBottom: '10px',
                      boxSizing: 'border-box',
                      fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
                    }}
                  />
                </div>

                <div className="flex col-12">
                  <label htmlFor="pwd">
                    <h5>Password</h5>
                  </label>
                  <div style={{ position: 'relative', width: '100%' }}>
                       <input
                    placeholder=""
                    name="password"
                     type={showPassword ? "text" : "password"}
                    id="pwd"
                    className="form-control about-card-edit"
                    onChange={handleChange}
                        style={{
                      background: "rgba(37, 37, 36, 0.8)",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      boxShadow: `
                    0 0 5px rgba(73, 57, 31, 0.6),
                    0 0 10px rgba(67, 66, 64, 0.35)
                  `, 
                      color: 'white',
                      caretColor: 'white',
                      width: '100%',
                      paddingRight: '40px', // 👈 space for the icon
                      marginBottom: '10px',
                      boxSizing: 'border-box',
                      fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
                    }}
                  />
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: 'silver',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span className="eye-icon"
       style={{
    fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
    display: "flex",
    alignItems: "center",
    color: "white"
  }}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </button>
                  </div>
            

                </div>
                {error && (
                  <div>
                    <p className="error-text">{error}</p>
                  </div>
                )}
              </div>
            )}
          </div>

          {!forgotPassword && (
            <div className="flex col-12">
              <Button 
                type="submit" 
                className="process-card-text hover-brighten"
                style={{
                  display: 'block',
                  height: '40%',
                  width: 'auto',
                  margin: '10px auto',
                  fontSize: '2.5vmin',
                  backgroundColor: 'rgb(67, 66, 66)',
                  color: '#fff',
                   border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                  borderRadius: '999px',
                  padding: '0.4rem 1rem',
                  cursor: 'pointer',
                  textAlign: 'center',
                }}
              >
                <h5 style={{ margin: '1%' }}>Login</h5>
              </Button>
            </div>
          )}
          
          <CardText
          style={{
            marginTop: '1%'
          }}
          >
            Don't have an account? Sign up 
            <Link to="/Signup" className='go-to-signup-link'
              style={{
                color: 'white',
                fontWeight: 'bold', 
                textDecoration: 'none'
              }}
            > Here</Link>
          </CardText>

          {/* Forgot Password Button */}
          {!forgotPassword && (
            <div className="forgot-password-button d-flex justify-content-center col-12">
              <Button 
                onClick={() => setForgotPassword(true)}
                style={{ border: 'none', background: 'none', cursor: 'pointer',
                  
                 }}
              >
               <CardText
                 style={{
                  color: 'white',
                  fontWeight: 'bold', 
                  textDecoration: 'none'
                }}
                >Forgot Password?</CardText>
              </Button>
            </div>
          )}
        </Card>
      </form>
    </div>
  );
}

export default Login;
